import { IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "lucide-react";
import type { FC } from "react";

type Props = {
	direction: "left" | "right";
	color: string;
	onClick: () => void;
};

export const DashboardArrowButton: FC<Props> = ({
	direction,
	color,
	onClick,
}) => {
	const Icon = direction === "left" ? ChevronLeft : ChevronRight;

	return (
		<IconButton
			disableRipple
			onMouseDown={(e) => e.preventDefault()}
			onClick={onClick}
			sx={{
				position: "absolute",
				[direction]: 8,
				top: 8,
				zIndex: 2,
			}}
		>
			<Icon size={32} color={color} />
		</IconButton>
	);
};
